import { ProblemData } from "../MathFactsGenerator/Constants.ts";

/**
 * The two sides of a flash card, as text.
 *
 * `ProblemData` stores operands positionally in `numbers` - `[top, bottom,
 * answer]`, and `[dividend, divisor, quotient, remainder]` once a division sheet
 * has `Remainders` on - with `operator` carrying the sign glyph the worksheet
 * prints (`+`, `-`, `x`, `÷`). There are no named `answer` / `remainder` fields,
 * so a card reads its faces off `numbers` the same way for every arithmetic
 * operator, division's backwards generation included.
 *
 * This is kept out of the component so it can be unit tested without mounting
 * anything - the same split WordProblemGenerator.ts uses against Word.tsx.
 */
export interface CardFaces {
    front: string;
    back: string;
}

export function cardFaces(problem: ProblemData): CardFaces {
    const [first, second, answer, remainder] = problem.numbers;
    const front = `${first} ${problem.operator} ${second}`;
    // A remainder of zero is not written down. The worksheet's answer key makes
    // the same call - see the `numbers[3] > 0` guard in Problems-UI/MathFacts.tsx
    // - and the two have to agree, or one problem prints as "7" on paper and
    // "7 r 0" on the card cut from it.
    const back = remainder ? `${answer} r ${remainder}` : String(answer);
    return { front, back };
}
